import { z } from 'zod'

import { AdUnitForForm } from '../GeneralForm/hooks/useGetAdUnit'

export const schema = z.object({
  allowMultiformatEnabled: z.boolean(),
  id: z.string(),
  unfilledRecoveryEnabled: z.boolean(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  adUnitUnfilledRecovery: { allowMultiformatEnabled },
  id,
  unfilledRecoveryEnabled,
}: AdUnitForForm): Schema => ({
  allowMultiformatEnabled,
  id,
  unfilledRecoveryEnabled,
})
